// extracted by mini-css-extract-plugin
module.exports = {"button":"AnimatedBallButton_button__3yQgp","content":"AnimatedBallButton_content__X3sRh","button__icon":"AnimatedBallButton_button__icon__IdpzB"};